import React from "react";
import { Route, Routes } from "react-router-dom";
import PickRoute from "./pick-route";

const Warehouse = () => {
  return (
    <Routes>
      <Route path="pick-route" element={<PickRoute />} />
    </Routes>
  );
};

export default Warehouse;
